enum ColumnRatioOption {
  One = 1,
  Two = 2,
  Three = 3,
}

export { ColumnRatioOption };
